<template>
  <div class="action-btn__wrapper">
    <Spin v-if="loading"></Spin>
    <Icon class="icon" type='md-checkmark' size='24' color='#35C030' @click="approve(row.username, 1)" v-if="row.verification == 0"/>
    <div>
      <p style="margin-right:3px" v-if="row.verification == 1">Approved</p>
      <p style="margin-right:3px" v-if="row.verification == 2">Declined</p>
      <Icon 
            type="md-create" 
            size="16"
            v-if="row.verification == 1 || row.verification == 2"
            class="icon-edit"
            @click="row.verification = 0"
            />
    </div>

    <Icon class="icon" type='md-close' size='24' color='#F65858' @click="approve(row.username, 2)" v-if="row.verification == 0"/>

  </div>
</template>

<script>
  export default {
    props: {
      row: {
        type: Object
      },
      column: {
        type: Object
      }
    },
    data: () => ({
      loading: false
    }),
    methods: {
      approve(id, status) {
        const data = {}
        data['username'] = id
        data['verification'] = status
        this.loading = true
        this.$store.dispatch('approveUser', data)
        .then(res => {
          location.reload()
          this.loading = false
        })
        .catch(err => {
          let error = err.response.data
          this.loading = false
          this.$Message.error({
              content: error.error,
              duration: 3
            })
        })
        
      }
    }
  }
</script>

<style lang="scss" scoped>
.action-btn__wrapper {
  display: flex;
  justify-content: center;
  position: relative;
  .icon-edit {
    position: absolute;
    top: 0;
    right: 0;
    cursor: pointer;
  }
}
</style>